import axios from 'axios'
import _ from 'lodash'
import ajax from "@/lib/ajax"
import moment from "moment"
import AppConsts from "@/lib/appconst";
import selectTreeBase from "@/components/treeSelectComps/selectTreeBase";

/**
 * 转换时间参数,主要处理表单传入参数含有moment对象的问题
 * @param obj 传入对象
 * @constructor
 */
const convertDateParam = function (obj) {
    _.each(obj, (val, prop) => {
        if (val instanceof moment) {
            obj[prop] = (val as any).format("YYYY-MM-DD HH:mm:ss");
        }

        if (val instanceof Date) {
            obj[prop] = moment(val).format("YYYY-MM-DD HH:mm:ss");
        }

    })
    return obj;
}


const setVueContextSpinState = function (vueContext, spinName: string) {
    if (vueContext && vueContext[spinName] != undefined) {
        vueContext[spinName] = true;
    }
}

const resetVueContextSpinState = function (vueContext, spinName: string) {
    if (vueContext && vueContext[spinName] == true) {
        vueContext[spinName] = false;
    }
}


class ajaxHelper {
    /****
     * 杨健荣
     * 下载单文件
     * ***/
    getOneFile(url, data = {}, config = {responseType: 'blob'}, vueContext = undefined, spinName = "spinning") {
        let reqData = _.map(data, (val, prop) => {
            return {"name": prop, "value": val}
        })
        data = abp.utils.buildQueryString(reqData);
        setVueContextSpinState(vueContext, spinName);
        return ajax.get(url + data, config).finally(() => {
            resetVueContextSpinState(vueContext, spinName);
        })
    }

    /***
     * 杨健荣
     * 下载zip压缩包
     * ***/
    postdown(url, data, vueContext = undefined, spinName = "spinning", config = {responseType: 'blob'}) {
        // let reqData = JSON.stringify(data);
        data = convertDateParam(data);
        setVueContextSpinState(vueContext, spinName);
        return ajax.post(url, data, config).finally(() => {
            resetVueContextSpinState(vueContext, spinName);
        })
    }

    /**
     * 发送单参数的DTO post请求
     * @param url 目标地址
     * @param data 数据
     * @param vueContext 目的上下文，主要用来取spin环境
     */
    postD(url, data, vueContext = undefined, spinName = "spinning", config = undefined) {
        // let reqData = JSON.stringify(data);
        data = convertDateParam(data);
        setVueContextSpinState(vueContext, spinName);

        return ajax.post(url, data, config).finally(() => {
            resetVueContextSpinState(vueContext, spinName);
        })
    }

    /**
     * 发送多参数的非DTO的多参数请求
     * @param url 目标URL
     * @param data 数据
     * @param spin 加载标识符
     */
    postM(url, data, vueContext = undefined, spinName = "spinning") {
        data = convertDateParam(data);
        let reqData = _.map(data, (val, prop) => {
            return {"name": prop, "value": val}
        })
        let reqStr = abp.utils.buildQueryString(reqData);
        console.log(JSON.stringify(reqStr));
        setVueContextSpinState(vueContext, spinName);

        return ajax.post(url + reqStr).finally(() => {
            resetVueContextSpinState(vueContext, spinName);
        })
    }

    /**
     * 我要提问单独
     * 发送多参数的非DTO的多参数请求
     * @param url 目标URL
     * @param data 数据
     * @param spin 加载标识符
     */
    postMyQ(url, data, vueContext = undefined, spinName = "spinning") {
        data = convertDateParam(data);
        setVueContextSpinState(vueContext, spinName);
        return ajax.post(url, data).finally(() => {
            resetVueContextSpinState(vueContext, spinName);
        })
    }

    /**
     * 发送多参数,且带DTO参数的 post请求
     * @param url 目标地址
     * @param urlParam url中拼接的参数(简单参数)
     * @param data 消息体内数据（DTO参数）
     * @param vueContext 目的上下文，主要用来取spin环境
     */
    postMD(url, urlParam, data, vueContext = undefined, spinName = "spinning") {
        // let reqData = JSON.stringify(data);
        data = convertDateParam(data);

        setVueContextSpinState(vueContext, spinName);
        let reqData = _.map(urlParam, (val, prop) => {
            return {"name": prop, "value": val}
        })
        let reqStr = abp.utils.buildQueryString(reqData);
        return ajax.post(url + reqStr, data).finally(() => {
            resetVueContextSpinState(vueContext, spinName);
        })
    }


    get(url, data = {}, config = undefined, vueContext = undefined, spinName = "spinning") {
        let reqData = _.map(data, (val, prop) => {
            return {"name": prop, "value": val}
        })
        data = abp.utils.buildQueryString(reqData);
        setVueContextSpinState(vueContext, spinName);
        return ajax.get(url + data, config).finally(() => {
            resetVueContextSpinState(vueContext, spinName);
        })
    }

    /**
     * 发送多参数,且带DTO参数的 get请求
     * @param url 目标地址
     * @param urlParam url中拼接的参数(简单参数)
     * @param data 消息体内数据（DTO参数）
     * @param vueContext 目的上下文，主要用来取spin环境
     */
    getMD(url, urlParam, data = {}, config = undefined, vueContext = undefined, spinName = "spinning") {
        let reqParam = _.map(urlParam, (val, prop) => {
            return {"name": prop, "value": val}
        })
        let reqData = _.map(data, (val, prop) => {
            return {"name": prop, "value": val}
        })
        urlParam = abp.utils.buildQueryString(reqParam);
        data = abp.utils.buildQueryString(reqData).replace('?', '&');
        setVueContextSpinState(vueContext, spinName);
        return ajax.get(url + urlParam + data, config).finally(() => {
            resetVueContextSpinState(vueContext, spinName);
        })
    }

    put(url, data, vueContext = undefined, spinName = "spinning") {
        // let reqData = JSON.stringify(data);
        data = convertDateParam(data);

        setVueContextSpinState(vueContext, spinName);

        return ajax.put(url, data).finally(() => {
            resetVueContextSpinState(vueContext, spinName);
        })
    }

    delete(url, data, config = undefined, vueContext = undefined, spinName = "spinning") {
        // let reqData = JSON.stringify(data);
        let reqData = _.map(data, (val, prop) => {
            return {"name": prop, "value": val}
        })
        data = abp.utils.buildQueryString(reqData);

        setVueContextSpinState(vueContext, spinName);

        return ajax.delete(url + data, config).finally(() => {
            resetVueContextSpinState(vueContext, spinName);
        })
    }

    /**
     * @描述：文件下载
     * @作者: 张俊
     * @创建时间: 2020-03-30 16:03:39
     */
    download(url: string, data) {
        url = url.replace('\\wwwroot', AppConsts.remoteServiceBaseUrl).replace(/\\/g, '\/');
        //在本页打开窗口
        let $eleForm = $("<form method='get'></form>");
        $eleForm.attr("action", url);
        $(document.body).append($eleForm);
        //提交表单，实现下载
        $eleForm.submit();


        // if (url) {
        //     url = url.replace('\\wwwroot', AppConsts.remoteServiceBaseUrl).replace(/\\/g, '\/');
        //     debugger
        //     axios.get(url,{
        //         params: data,
        //         headers:  'Access-Control-Allow-Origin:*',
        //         responseType: 'blob'
        //     }).then(response => {
        //         debugger
        //         if (!response) {
        //             return
        //         }
        //
        //         let url = window.URL.createObjectURL(new Blob([response as any]))
        //         let link = document.createElement('a')
        //         link.style.display = 'none'
        //         link.href = url
        //         link.setAttribute('download', 'excel.xlsx')
        //
        //         document.body.appendChild(link)
        //         link.click()
        //     }).catch((error) => {
        //         debugger
        //         alert(error);
        //     })
        // }
    }

}

const ajaxHelperInstance = new ajaxHelper()

export default ajaxHelperInstance
